<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md6>
        <v-card class="pa-5">
          <div>
            <h2 CLASS="text--primary text-uppercase">{{$t('New Password')}}</h2>
            <p class="caption">{{$t('Please enter your new password and the the verification code send to you by email')}}</p>
          </div>
          <v-card-text class="pa-0">
            <v-form ref="loginForm">
              <v-text-field
                outlined
                v-model="userObj.newPassword"
                :rules="[v=> !!v || $t('Password is required')]"
                :placeholder="$t('Password *')"
                type="password">
              </v-text-field>
              <v-text-field
                outlined
                v-model="userObj.token"
                :rules="[v=> !!v || $t('Verification code is required')]"
                :placeholder="$t('Verification code *')"
                >
              </v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions class="d-block text-center">
            <v-btn :loading="loader"  width="150" @click="login" elevation="0" color="primary">{{$t('Send')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    data() {
      return {
        dobMenu: false,
        userObj: {
          newPassword: '',
          token: '',
          email: '',
          lang: ''
        },
        loader: false
      }
    },
    methods: {
      login () {

        if (this.$refs.loginForm.validate()) {
          this.loader = true
          this.userObj.lang = this.$i18n.locale
          this.userObj.email = this.$route.query.email
          this.$http_sys_no_auth.post('Authentication/ResetPasswordToken',this.userObj)
            .then(response=>{
              this.$store.dispatch('setSnackBarMessage',response.data.message)
              this.loader = false
            })
            .catch(error=>{
              this.loader = false
              this.$store.dispatch('setSnackBarMessage',error.response.data.errorMessage)
            })
        }
      },
      saveDob (date) {
        this.$refs.dobMenu.save(date)
      },
    },
    watch: {
      dobMenu (val) {
        val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
      },
    }
  }
</script>
<style>

</style>
